import { ForgotPasswordPage } from './ForgotPasswordPage'

export const DefinePasswordPage = () => {
  return (
    <ForgotPasswordPage
      pageTitle="Définir un mot de passe"
      title="Entrez votre e-mail pour recevoir un lien de définition du mot de passe"
      buttonText="Envoyer"
    />
  )
}